import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { socketSetup } from "../../library/socket-io/socket-setup";
import { actuarialApi } from "../../api/actuarial/actuarial-api";
import { useModalAccess } from "../../components/global/modal/use-modal-access";

interface SocketPayload {
    proposalId: number;
}

export const useForApprovalSocket = () => {
    const dispatch = useDispatch();
    const { currentProposalId } = useModalAccess();

    const invalidate = useCallback(
        ({ proposalId }: SocketPayload) => {
            // Always refresh the approval queue for everyone
            dispatch(
                actuarialApi.util.invalidateTags([
                    { type: "ComputationApproval", id: "LIST" },
                ])
            );

            // Ignore proposal-specific updates for other proposals
            if (proposalId !== currentProposalId) return;

            // Refresh the currently opened proposal
            dispatch(
                actuarialApi.util.invalidateTags([
                    { type: "ComputationApproval", id: proposalId },
                    { type: "ComputationApprovalHistory", id: proposalId },
                    { type: "Proposal", id: proposalId },
                ])
            );
        },
        [dispatch, currentProposalId]
    );

    useEffect(() => {
        if (!socketSetup) return;

        socketSetup.on("actuarialPassApproval", invalidate);
        socketSetup.on("actuarialDenyApproval", invalidate);
        socketSetup.on("actuarialSubmitApproval", invalidate);

        return () => {
            socketSetup.off("actuarialPassApproval", invalidate);
            socketSetup.off("actuarialDenyApproval", invalidate);
            socketSetup.off("actuarialSubmitApproval", invalidate);
        };
    }, [invalidate]);
};